import {
    LIST_MENU,
    CREATE_MENU,
    UPDATE_MENU,
    DELETE_MENU,
    LIST_ROLE_MENU,
    CREATE_ROLE_MENU,
    UPDATE_ROLE_MENU,
    DELETE_ROLE_MENU
} from "../constant";
import axios from 'axios';
import * as REPO from '../helper/main'

const localKey = 'token';

export const getListMenu = () => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.get(LIST_MENU, config_token);
};

export const postMenu = data => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.post(CREATE_MENU, data, config_token);
};

export const updateMenu = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_MENU + id, data, config_token);
};

export const deleteMenu = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.delete(DELETE_MENU + id, config_token);
};

export const getListRoleMenu = (body) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    let param = REPO.bikinParam(body);
    return axios.get(LIST_ROLE_MENU + param, config_token);
};

export const postRoleMenu = data => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.post(CREATE_ROLE_MENU, data, config_token);
};

export const updateRoleMenu = (data, id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.put(UPDATE_ROLE_MENU + id, data, config_token);
};

export const deleteRoleMenu = (id) => {
    let config_token = {
        headers: REPO.getAuthHeader()
    };
    return axios.delete(DELETE_ROLE_MENU + id, config_token);
};

